"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _utils = require("../../utils");

var _truncate = _interopRequireDefault(require("./truncate"));

var _excluded = ["charCount", "collapseText", "description", "display", "expandText", "font", "titleColor"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  /** A number used for the max no. of chars displayed before truncation */
  charCount: _propTypes.number,

  /** A node used for a collapse action */
  collapseText: _propTypes.node,

  /** A string used for the description text */
  description: _propTypes.string,
  display: (0, _propTypes.arrayOf)(_propTypes.string),

  /** A node used for an expand action */
  expandText: _propTypes.node,

  /** font config for font type */
  font: _utils.fontPropType,

  /** A string for title color */
  titleColor: _propTypes.string
};

var Description = function Description(_ref) {
  var charCount = _ref.charCount,
      collapseText = _ref.collapseText,
      description = _ref.description,
      display = _ref.display,
      expandText = _ref.expandText,
      font = _ref.font,
      titleColor = _ref.titleColor,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var _useToggle = (0, _utils.useToggle)(true),
      shouldTruncate = _useToggle[0],
      toggleTruncate = _useToggle[1];

  var truncatedText = (0, _react.useMemo)(function () {
    return (0, _utils.truncateHtml)(description, charCount);
  }, [description, charCount]);
  var showEllipsis = (0, _react.useMemo)(function () {
    return (0, _utils.getInnerTextOfHtml)(description, charCount).length > charCount;
  }, [description, charCount]);
  return /*#__PURE__*/_react["default"].createElement(_truncate["default"], _extends({
    buttonText: shouldTruncate ? expandText : collapseText,
    description: shouldTruncate ? truncatedText : description,
    display: display,
    font: font,
    showEllipsis: showEllipsis,
    titleColor: titleColor,
    toggleTruncate: toggleTruncate
  }, props));
};

Description.propTypes = propTypes;
Description.displayName = "Modules.Description";
var _default = Description;
exports["default"] = _default;